import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';

import { Button } from '../../shared/ui/button';
import { LoadingState } from '../../shared/ui/states';
import { ApiError } from '../../shared/api/errors';
import { confirmEmail } from '../../entities/session';
import { AuthScreen } from './ui/auth-screen';

// Never retried: the token is single-use, so a second attempt turns a success into an error.
export const ConfirmEmailPage = ({ token }: { token: string }) => {
  const confirm = useQuery({
    queryKey: ['confirm-email', token],
    queryFn: async () => {
      await confirmEmail(token);
      return true;
    },
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  if (confirm.isPending) {
    return (
      <AuthScreen title="Confirming your address" brand={false}>
        <div className="mt-section">
          <LoadingState rows={2} />
        </div>
      </AuthScreen>
    );
  }

  if (confirm.isError) {
    const api = confirm.error instanceof ApiError ? confirm.error : null;

    return (
      <AuthScreen
        title="This link no longer works"
        brand={false}
        description="A confirmation link can be used once. Ask for a new one from your profile."
      >
        {api && <p className="mt-4 font-mono text-meta text-faint">{api.message}</p>}
        <div className="mt-section">
          <Link to="/sign-in">
            <Button variant="ghost" block>
              Back to sign in
            </Button>
          </Link>
        </div>
      </AuthScreen>
    );
  }

  return (
    <AuthScreen
      title="Address confirmed"
      brand={false}
      description="Notifications can reach you now."
    >
      <div className="mt-section">
        <Link to="/flows">
          <Button block>Open Hookpipe</Button>
        </Link>
      </div>
    </AuthScreen>
  );
};
